export default __webpack_public_path__ + "static/media/bw-reaction-speed-tutorial-pop-up-step-3.b7daab23.svg";